












import Vue from 'vue'
export default Vue.extend({
  name: 'IconTrash',
  props: {
    color: {
      type: String,
    },
  },
})
